import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
import { openLoader, closeLoader } from '../../../../../../redux-store/loader'
import { closeModal, openModal } from '../../../../../../redux-store/modal'
import PaymentModel from '../../../../../../data/models/payment/payment'
import I18n from '../../../../../../i18n'
import { Form, Button, Label } from 'semantic-ui-react'
import { required } from '../../../../../../config/validations';
import CustomInput from '../../../../../components/form/input'
import Select from '../../../../../components/form/Select'

// Styles
import './extendProLicenses.scss'

class ExtendProLicenses extends Component {
  constructor(props) {
    super(props)

    this.state = {
      planOptions: []
    }
  }

  componentDidMount() {
    this.getPlans();
  }

  getPlans = async () => {
    try {
      this.props.openLoader();
      const response = await PaymentModel.getProPlans();
      const plans = response.data;

      // 1. Guardamos el maxStudents original en las opciones
      const options = plans.map(plan => ({
        key: plan._id,
        text: plan.name,
        value: plan._id,
        maxStudents: plan.maxStudents // Agregado aquí
      }));

      this.setState({
        loaded: true,
        planOptions: options,
      });

    } catch (error) {
      console.error("error", error);
    } finally {
      this.props.closeLoader();
      this.setState({ loaded: true });
    }
  };

  // 2. Función para manejar el cambio en el selector de plan
  handlePlanChange = (event, newValue) => {
    const { change } = this.props; // Extraemos la función change de redux-form

    // Buscamos el plan seleccionado en nuestras opciones
    const selectedPlan = this.state.planOptions.find(plan => plan.value === newValue);

    if (selectedPlan && selectedPlan.maxStudents !== undefined) {
      // Si hay plan y tiene maxStudents, seteamos el valor por defecto
      change('maxStudents', selectedPlan.maxStudents);
    } else {
      // Si se deselecciona el plan o no tiene limite, lo dejamos vacío
      change('maxStudents', '');
    }
  }

  handleExtendProLicense = async ({ days, planId, maxStudents }) => {

    let messageError = {
      headerTitle: "Error",
      title: I18n.t('messages.modal.commonError'),
      buttons: [
        {
          text: I18n.t('actions.accept'),
          callback: () => this.props.closeModal()
        }
      ]
    };

    const title = days > 0 ? "messages.modal.proLicenseExtended" : "messages.modal.proLicenseReduced";

    let messageCorrect = {
      title: I18n.t(title, { days }),
      buttons: [
        {
          text: I18n.t('actions.accept'),
          callback: () => this.props.closeModal()
        }
      ]
    };

    // 3. Construimos el payload de manera dinámica
    const payload = {
      days: parseInt(days),
      planId
    };

    // Solo mandamos maxStudents si existe, no es string vacío y hay un plan seleccionado
    if (planId && maxStudents !== undefined && maxStudents !== '') {
      payload.maxStudents = parseInt(maxStudents);
    }

    try {
      this.props.openLoader();
      await PaymentModel.extendProLicense(this.props.userid, payload);
      this.props.openModal(messageCorrect);
      this.props.getProLicences();

    } catch (error) {
      this.props.closeLoader();
      this.props.openModal(messageError);
    } finally {
      this.props.closeLoader();
    }
  }

  render() {
    return (
      <Form className="proLicenseForm" name="proLicenseForm" onSubmit={this.props.handleSubmit(this.handleExtendProLicense)}>
        <div className='proLicenseFormFields'>
          <Label>
            {I18n.t('pro.info.days')}
            <Field
              component={CustomInput}
              placeholder={''}
              name="days"
              inline={true}
              validate={[required]}
              restrictions={[{ numeric: true }]}
            />
          </Label>
          <Label>
            {I18n.t('pro.info.plan')}
            <Field
              component={Select}
              name="planId"
              placeholder={''}
              options={this.state.planOptions}
              style={{ marginRight: '2rem' }}
              clearable={true}
              onChange={this.handlePlanChange} // Evento agregado aquí
            />
          </Label>
          <Label>
            {I18n.t('pro.info.maxStudents')}
            <Field
              component={CustomInput}
              name="maxStudents"
              placeholder={''}
              clearable={true}
              restrictions={[{ numeric: true }]} // Sugerencia: restringir a numérico si aplica
            />
          </Label>
        </div>
        <Form.Field>
          <Button floated="left" content={I18n.t('user.info.extend')} icon='plus' labelPosition='right' size="mini" />
          <div style={{ clear: "both" }}></div>
        </Form.Field>
      </Form>
    )
  }
}

export default reduxForm({
  form: 'proLicenseForm',
  touchOnBlur: true,
  touchOnChange: false,
  initialValues: {
    days: 0,
    planId: "",
    maxStudents: "" // Inicializado vacío
  }
})(connect(null, { openLoader, closeLoader, closeModal, openModal })(ExtendProLicenses));